<template>
  <div class="homapt-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-9">
          <router-view></router-view>
        </div>
        <div class="col-lg-3">
          <business-subnav></business-subnav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BusinessSubnav from './BusinessSubnav.vue'

export default {
  components: {
    businessSubnav: BusinessSubnav
  }
}
</script>

<style>
.homapt-wrapper {
  padding-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/BusinessProfile.vue